<template>
  <div class="u-16 state-history">
    <div class="u grid between">
      <h2 class="u">История состояний</h2>
      <div class="field">
        <b-switch size="is-small" v-model="isFull" type="is-info"
          >Вся история</b-switch
        >
      </div>
    </div>

    <b-table
      :data="orderTraces"
      striped
      narrowed
      mobile-cards
      class="u-16 states ver-margin-10"
    >
      <template
        slot-scope="props"
        v-if="isFull || !isInProgress(props.row.processing_state_id)"
      >
        <b-table-column
          field="date_updated"
          label="Дата"
          sortable
          width="180"
          >{{ props.row.date_updated | momentFormat() }}</b-table-column
        >
        <b-table-column field="state_id" label="Статус" class="status">
          <span
            class="status-tag"
            :class="
              isFull && isInProgress(props.row.processing_state_id)
                ? statusStyle(props.row.processing_state_id)
                : statusStyle(props.row.state_id)
            "
            >{{
              isFull && isInProgress(props.row.processing_state_id)
                ? statusName(props.row.processing_state_id)
                : statusName(props.row.state_id)
            }}</span
          >
        </b-table-column>
        <b-table-column field="amount" label="Сумма" width="100"
          >{{ props.row.amount | amountFormat }}
          {{ currencyCharacter(props.row.currency_code) }}</b-table-column
        >
        <b-table-column v-if="showLogs()" label="Логи" centered>
          <log-view :trace="props.row" v-if="props.row.processing_state_id > 0 || props.row.state_id !== 1"></log-view>
        </b-table-column>
        <b-table-column label="Справка" centered>
          <span
            v-if="
              props.row.isShow &&
                (props.row.state_id == -1 ||
                  props.row.state_id == 3 ||
                  props.row.state_id == 8 ||
                  props.row.state_id == 6 ||
                  props.row.state_id == 10 ||
                  props.row.state_id == 16 ||
                  props.row.state_id == 20)
            "
          >
            <el-button
              icon="el-icon-document"
              class="pdf-button"
              type="text"
              @click="createPdf(props.row)"
              >PDF</el-button
            >
          </span>
        </b-table-column>
        <b-table-column field="created_by" label="Изменен" width="100">{{
          props.row.created_by
        }}</b-table-column>
      </template>

      <template slot="empty">
        <section>
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad"></b-icon>
              <br />Нет данных
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import Vuex from "vuex";
import { mapGetters } from "vuex";
import { _ } from "underscore";
import VueAxios from "vue-axios";
import moment from "moment";

import { getDataUri } from "./getdatauri.js";

import pdfLogo from "@/assets/images/logo-map.png";
import pdfBg from "@/assets/images/background.jpg";
import r from "../localize/rights";
import LogView from "./LogView";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "StatusHistory",
  components: {LogView},
  props: {
    orderTraces: {
      type: Array,
      required: true
    },
    orderInfo: {
      type: Object,
      required: true
    },

  },
  data() {
    return {
      isShow: true,
      isFull: false,
      dataLogo: "",
      dataBg: "",
      pdfLoading: false,
    };
  },
  methods: {
    showLogs() {
      return !!(this.getProfile.is_admin || this.hasRight(r.SHOW_BANK_LOGS))
    },
    // Genegate PDF
    createPdf(row) {
      let data = this.orderInfo;
      this.pdfLoading = true;
      // get description value
      var custom_params = data.custom_params;
      var descripion = "";
      if (custom_params != null) {
        var temp = custom_params.filter(el => el.k === "description");
        if (temp.length > 0) descripion = temp[0].v;
      }

      // convert date to local
      var utc = moment.utc(row.date_created).toDate();
      var dateState = moment(utc).local();

      // generate table body
      var bodyTable = [
        ["Статус", this.statusName(row.state_id)],
        [
          "Карта",
          data.bank_country_code + ", " + data.bank_name + ", " + data.pan_mask
        ]
      ];
      // check state_id
      if (row.state_id == -1) {
        bodyTable.push(["Причина отказа", data.processing_error_code]);
      } else {
        bodyTable.push(["Код авторизации", data.auth_code]);
      }
      bodyTable.push(["RRN", data.rrn]);
      bodyTable.push(["Описание заказа", descripion]);

      var dataLogo;

      var docDefinition = {
        defaultStyle: {
          fontSize: 10
        },
        content: [
          {
            image: "logoMap",
            width: 100,
            absolutePosition: { x: 30, y: 70 }
          },
          {
            image: "imgBg",
            width: 397,
            absolutePosition: { x: 203, y: -30 }
          },
          // {
          //   image: "stamp",
          //   width: 120,
          //   absolutePosition: { x: 350, y: 650 }
          // },
          {
            text: "Операция по заказу № " + data.merchant_order_id,
            fontSize: 13,
            bold: true,
            margin: [0, 100, 0, 0]
          },
          {
            text: [
              "Сумма ",
              {
                text: parseFloat(row.amount / 100)
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1 ")
              },
              { text: " " + this.currencyCharacter(row.currency_code) + "\n" },
              {
                text: moment(dateState).format("DD MMMM YYYY HH:mm"),
                color: "#666666"
              },
              "\nВладелец карты " + data.card_holder
            ],
            fontSize: 10,
            lineHeight: 1.3,
            margin: [0, 20, 0, 20]
          },
          {
            canvas: [
              {
                type: "rect",
                x: 1,
                y: 1,
                w: 520,
                h: 1,
                lineColor: "#efefef"
              }
            ]
          },
          {
            text: "Информация о платеже",
            fontSize: 16,
            margin: [0, 20, 0, 20]
          },
          {
            table: {
              style: "orderInfo",
              border: "undefined",
              widths: [100, "*"],
              body: bodyTable
            },
            layout: {
              fillColor: function(i, node) {
                return i % 2 === 0 ? "#efefef" : null;
              },
              hLineColor: function(i, node) {
                return i === 0 || i === node.table.body.length
                  ? "#dedede"
                  : "#dedede";
              },
              vLineColor: function(i, node) {
                return i === 0 || i === node.table.widths.length
                  ? "#ffffff"
                  : "#ffffff";
              }
            }
          },
          {
            text:
              "С указанными данными держатель карты может обратиться в банк, выпустивший карту, для уточнения актуального состояния платежа.",
            margin: [0, 40, 0, 20]
          },
          // {
          //   text: "Генеральный директор\nООО «MAP»",
          //   absolutePosition: { x: 40, y: 700 }
          // },
          // {
          //   text: "Роганов М.Н.",
          //   absolutePosition: { x: 40, y: 700 },
          //   alignment: "right"
          // },
          {
            text: "© MAP, " + new Date().getFullYear(),
            style: "bottom",
            absolutePosition: { x: 40, y: 790 },
            alignment: "right"
          }
        ],
        images: {
          imgBg: this.dataBg,
          logoMap: this.dataLogo,
          stamp: ""
        },
        styles: {
          orderInfo: {
            cellPaddings: 10,
            lineHeight: 20
          },
          bottom: {
            fontSize: 8
          }
        }
      };
      pdfMake.createPdf(docDefinition).download("Подтверждение_платежа.pdf");
      this.pdfLoading = false;
    }
  },
  mounted() {
    let _this = this;
    getDataUri(pdfLogo, function(data) {
      _this.dataLogo = data;
      return data;
    });
    getDataUri(pdfBg, function(data) {
      _this.dataBg = data;
      return data;
    });
  },
  destroyed() {
    this.dataLogo = "";
    this.dataBg = "";
  },
  computed: {
    ...mapGetters([
      "statusName",
      "statusStyle",
      "isInProgress",
      "currencyCharacter",
      "getProfile",
      "hasRight",
    ])
  }
};
</script>

<style lang="sass" scoped>
.pdf-button
  padding: 0
</style>
